import ReportInputs from './report-inputs'

const GET_REPORTS_URL = '/en/reports/get_reports/'
const REPORTS_PDF_URL = '/en/pdf/stats_report/'

export default class ReportsHandler {
    constructor(reportsContainer) {
        const reportInputGroup = document.querySelector('.report-inputs-group')
        if (reportInputGroup) {
            this.reportInputs = new ReportInputs(reportInputGroup)
        }
        this.activeReportInterval = reportsContainer.querySelector('.active-report-interval')
        this.existingHotlineData = reportsContainer.querySelector('#hotline-report-data')
        this.existingAnalystsData = reportsContainer.querySelector('#analysts-report-data')
        this.existingAceData = reportsContainer.querySelector('#ace-report-data')
        this.hotlineDataLoader = reportsContainer.querySelector('#hotline-loader')
        this.analystsDataLoader = reportsContainer.querySelector('#analysts-loader')
        this.aceDataLoader = reportsContainer.querySelector('#ace-loader')
        this.hotlineNoData = reportsContainer.querySelector('#hotline-no-data')
        this.analystsNoData = reportsContainer.querySelector('#analysts-no-data')
        this.aceNoData = reportsContainer.querySelector('#ace-no-data')
        this.pdfBtn = document.querySelector('.pdf-btn')
        this.hotlineOfficialNameSpans = document.querySelectorAll('.hotline-official-name')

        this.hotlineReportColumns = []
        this.analystsReportsColumns = []
        this.aceReportColumns = []
        if (this.existingHotlineData) {
            this.hotlineReportColumns = this.existingHotlineData.getAttribute('data-columns').split(',')
        }
        if (this.existingAnalystsData) {
            this.analystsReportsColumns = this.existingAnalystsData.getAttribute('data-columns').split(',')
        }
        if (this.existingAceData) {
            this.aceReportColumns = this.existingAceData.getAttribute('data-columns').split(',')
        }

        this.pdfBtn?.addEventListener('click', e => {
            e.preventDefault()
            const hotline = this.reportInputs.hotline.value
            const reportType = this.reportInputs.reportType.value
            const reportInterval = this.reportInputs.reportInterval.value

            let link = document.createElement('a')
            link.download = `${hotline}_${reportType}_report_${reportInterval}.pdf`
            link.href = `${REPORTS_PDF_URL}?hotline=${hotline}&report_type=${reportType}&report_interval=${reportInterval}`
            link.click()
        })

        this.reportInputs?.reportInterval.addEventListener('change', e => {
            e.preventDefault()
            // update report title upon report interval selection
            this.activeReportInterval.innerHTML = this.reportInputs.reportInterval.value
            this.updateReports()
        })

        this.reportInputs?.reportType.addEventListener('change', e => {
            e.preventDefault()
            this.clearExistingReports()
            this.activeReportInterval.innerHTML = "No Report Selected"
            this.hotlineNoData.classList.remove('u-vh')
            this.analystsNoData.classList.remove('u-vh')
            this.aceNoData.classList.remove('u-vh')
        })
    }

    updateReports() {
        const selectedHotline = this.reportInputs.hotline.value
        const selectedReportType = this.reportInputs.reportType.value
        const selectedReportInterval = this.reportInputs.reportInterval.value
        // clear report data and show spinners
        this.clearExistingReports()
        this.hideAllHidableRows()
        this.hotlineDataLoader.classList.remove('u-vh')
        this.analystsDataLoader.classList.remove('u-vh')
        this.aceDataLoader.classList.remove('u-vh')

        fetch(
            `${GET_REPORTS_URL}?hotline=${selectedHotline}&report_type=${selectedReportType}&report_interval=${selectedReportInterval}`,
            {method: 'get'}
        ).then(response => {
            this.hideAllHidableRows()
            if (response.ok) {
                return response.json()
            } else {
                throw response
            }
        }).then(json_data => {
            // set the report name spans
            let hotlineOfficialName = json_data['hotline_official_name']
            this.hotlineOfficialNameSpans.forEach((el) => {
                el.innerHTML = hotlineOfficialName
            })
            // generate reports
            const hotlineReport = json_data['hotline_report']
            const analystsReports = json_data['analysts_reports']
            const aceUsageReport = json_data['ace_usage_report']
            if (hotlineReport == null) {
                this.hotlineNoData.querySelector('.no-data-cell').innerHTML = 'No reports found'
                this.hotlineNoData.classList.remove('u-vh')
            }
            if (analystsReports.length === 0) {
                this.analystsNoData.querySelector('.no-data-cell').innerHTML = 'No reports found'
                this.analystsNoData.classList.remove('u-vh')
            }
            if (aceUsageReport == null) {
                this.aceNoData.querySelector('.no-data-cell').innerHTML = 'No reports found'
                this.aceNoData.classList.remove('u-vh')
            }
            this.addReportDataRow(this.existingHotlineData, hotlineReport, this.hotlineReportColumns)
            analystsReports.forEach(entry => this.addReportDataRow(this.existingAnalystsData, entry, this.analystsReportsColumns))
            this.addReportDataRow(this.existingAceData, aceUsageReport, this.aceReportColumns)
        }).catch(error => {
            console.error(error)
            // show no data cell with message
            this.hotlineNoData.querySelector('.no-data-cell').innerHTML = error.error
            this.analystsNoData.querySelector('.no-data-cell').innerHTML = error.error
            this.aceNoData.querySelector('.no-data-cell').innerHTML = error.error
        })
    }

    clearExistingReports() {
        if (this.existingHotlineData) {
            this.existingHotlineData.innerHTML = ''
        }
        if (this.existingAnalystsData) {
            this.existingAnalystsData.innerHTML = ''
        }
        if (this.existingAceData) {
            this.existingAceData.innerHTML = ''
        }
    }

    hideAllHidableRows() {
        this.hotlineDataLoader.classList.add('u-vh')
        this.analystsDataLoader.classList.add('u-vh')
        this.aceDataLoader.classList.add('u-vh')
        this.hotlineNoData.classList.add('u-vh')
        this.analystsNoData.classList.add('u-vh')
        this.aceNoData.classList.add('u-vh')
    }

    addReportDataRow(rowElement, rowData, columns) {
        if (rowData != null) {
            let newRow = document.createElement('div')
            newRow.classList.add('flex-table-row')
            columns.forEach(col => {
                let columnCell = document.createElement('div')
                columnCell.classList.add('flex-table-cell')
                let cssClass = col.replaceAll('_','-')
                columnCell.classList.add(cssClass)
                if (rowData[col] != null) {
                    columnCell.innerHTML = rowData[col]
                } else {
                    columnCell.innerHTML = 'N/A'
                }
                newRow.appendChild(columnCell)
            })
            rowElement.appendChild(newRow)
        }
    }
}